import React, { Component } from "react";
import MenuService from "../../../api/Menu/MenuService";
import {
  Space,
  Button,
  Row,
  Col,
  Divider,
  Card,
  Tabs,
  Drawer,
  Empty,
} from "antd";
import { toast } from "react-toastify";
import { DeleteFilled } from "@ant-design/icons";
import "./style.scss";

const { TabPane } = Tabs;

export default class ProductsMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMenu: null,
      products: [],
      types: [],
      groups: [],
      visible: false,
      selectedItem: null,
      selectedGroup: null,
      placement: "right",
    };

    this.handleEvent = this.handleEvent.bind(this);
    this.selectItem = this.selectItem.bind(this);
  }

  componentDidMount() {
    this.getSelectedMenu();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  removeItem = (id) => {
    let items = this.state.items;
    items.map((item, i) => item.id === id && items.splice(i, 1));
    this.setState({ items });
  };

  IncrementQuantity = (id) => {
    let items = this.state.items;
    items.map((item, i) => {
      if (item.id === id) {
        item.quantity++;
        item.totalAmount = item.quantity * item.price;
      }
      return item;
    });
    this.setState({ items });
  };

  DecrementQuantity = (id) => {
    let items = this.state.items;
    items.map((item, i) => {
      if (item.id === id) {
        item.quantity--;
        item.totalAmount = item.quantity * item.price;

        if (item.quantity === 0) {
          items.splice(i, 1);
        }
      }
      return item;
    });
    this.setState({ items });
  };

  selectItem = (e, item) => {
    e.preventDefault();
    let serviceId = localStorage.getItem("sId");
    if (
      item.prices.filter((price) => price.serviceId === serviceId).length > 0
    ) {
      let price = item.prices
        .sort((a, b) => a.createdAt > b.createdAt)
        .filter((price) => price.serviceId === serviceId)[0].price;
      if (this.state.items.filter((itm) => itm.id === item.id).length === 0)
        this.setState({
          items: [
            ...this.state.items,
            {
              id: item.id,
              name: item.name,
              quantity: 1,
              price: price,
              totalAmount: 1 * price,
              action: (
                <Space size="middle">
                  <Button
                    type="text"
                    onClick={() =>
                      this.setState({
                        items: this.state.items.filter(
                          (itm) => itm.id !== item.id
                        ),
                      })
                    }
                  >
                    <DeleteFilled />
                  </Button>
                </Space>
              ),
            },
          ],
        });
      else this.IncrementQuantity(item.id);
    } else {
      toast.error("Item price not set for this service Type", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  selectGroup = (group) => {
    this.setState({ selectedGroup: group });
  };

  confirmItems = () => {
    //add order here
    if (this.state.items.length > 0) {
      let itemList = [];
      this.state.items.map((item, i) =>
        itemList.push({
          itemId: item.id,
          quantity: item.quantity,
          price: item.price,
          totalAmount: parseInt(item.quantity) * item.price,
        })
      );
      //   orderService
      //     .addItemToOrder(this.state.order.id, itemList)
      //     .catch((err) => {
      //       console.log(err);
      //       toast.error(err.message, {
      //         position: toast.POSITION.TOP_CENTER,
      //       });
      //     });
      this.setState({ showResult: true });
    } else {
      toast.warning("No Items to add to Order", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  getSelectedMenu = () => {
    MenuService.getAllMenus()
      .then((res) => {
        console.log("selected menu", res.data);
        let selectedMenu = res.data.filter(
          (menu) => menu.isSelected === true
        )[0];
        this.setState({ selectedMenu });
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  populateTypes = () => {
    console.log(this.state.selectedMenu);
    return (
      this.state.selectedMenu?.types?.length > 0 &&
      this.state.selectedMenu?.types.map((type, i) => {
        return (
          <TabPane tab={type.name} key={i} className="tabArea">
            <Row gutter={24} className="pl-3">
              {this.populateGroups(type)}
            </Row>
            <Row gutter={24}>
              <Divider />
            </Row>
            <Row gutter={24} className="pl-3">
              {this.state.selectedGroup !== null &&
                this.populateItems(this.state.selectedGroup)}
            </Row>
          </TabPane>
        );
      })
    );
  };
  populateGroups = (type) => {
    return type.itemGroups.map((group, i) => {
      return (
        <Col>
          <Card
            hoverable
            style={{ width: 80, height: 160 }}
            onClick={() => this.selectGroup(group)}
            className="card_group"
            cover={
              group.image !== null && (
                <img alt="example" src={group.image.filePath} />
              )
            }
          >
            <small className="card_group">{group.name}</small>
          </Card>
        </Col>
      );
    });
  };
  populateItems = (group) => {
    console.log("group", group);
    return group ? (
      group.items.map((item, i) => {
        return (
          <Col>
            <Card
              hoverable
              style={{ width: 80, height: "60%" }}
              onClick={(e) => this.selectItem(e, item)}
              className="card_group"
              cover={
                item.image !== null && (
                  <img alt="example" src={item.image.filePath} />
                )
              }
            >
              <small className="card_group">{item.name}</small>
            </Card>
          </Col>
        );
      })
    ) : (
      <Empty />
    );
  };

  render() {
    const { placement, visible } = this.state;
    return (
      <Row gutter={24} className="pt-0 p-0 m-0">
        <div class="container">
          <div class="vertical-center">
            <Button
              className="side-red-rounded-button"
              onClick={this.showDrawer.bind(this)}
            >
              <span className="red-button-text">Products</span>
            </Button>
          </div>
        </div>
        <Drawer
          width={800}
          placement={placement}
          closable={true}
          onClose={this.onClose}
          visible={visible}
          key={placement}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Tabs type="card">{this.populateTypes()}</Tabs>
            </Col>
          </Row>
        </Drawer>
      </Row>
    );
  }
}
